import React, { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { MODAL_TYPES, useGlobalModalContext } from '../../../components/GlobalModal';
import { convertBase64ToBlob, sendMessageToWebViewWrapper } from '../../../helpers/Functions';
import { setUserData } from '../../../redux/member';
import { RootState } from '../../../redux/store';
import { uploadProfileImage } from '../../../services/mediaService';
import { MemberMediaProps } from '../../../typings/memberMedia';
import { Box, CircularProgress, Modal, Typography } from '@mui/material';
import NiceModal from "@ebay/nice-modal-react";

type ImageContainerProps = {
    image: MemberMediaProps | null;
    confirmDeleteImage: (imageData: MemberMediaProps) => void;
    updateState: () => void;
    toggleIsLoading: () => void;
    switchToProfilePicture: (imageData: MemberMediaProps) => void;
}

const ImageContainer = ({ image, confirmDeleteImage, updateState, toggleIsLoading, switchToProfilePicture }: ImageContainerProps) => {

    const inputFile = useRef<any>(null);
    const { showModal } = useGlobalModalContext();
    const member = useSelector((state: RootState) => state.member);
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = React.useState<boolean>(false);

    useEffect(() => {
        document.addEventListener('upload-image', (e: any) => onMobileImageSelected(e.detail.base64image));
    }, [])

    const onMobileImageSelected = (base64image: string) => {
        showCropper(base64image);
    }

    const openUploadFile = () => {
        // if (window.platform === 'android') {
        //     sendMessageToWebViewWrapper({
        //         action: 'openCamera',
        //         payload: { source: 'gallery' }
        //     })
        // } else {
        if (inputFile.current) {
            inputFile.current.click()
            // }
        }
    };

    const onSelectFile = (e: any) => {
        const imageFile = e.target.files[0]
        const reader = new FileReader();
        reader.readAsDataURL(imageFile)
        reader.onload = () => {
            showCropper(reader.result);
        };
    }

    const showCropper = (base64image: string | ArrayBuffer | null) => {
        showModal(MODAL_TYPES.IMAGE_CROPPER, {
            imgURL: base64image,
            setCropImage: uploadCropImage,
            buttonText: "שמור תמונה"
        });

    };

    const uploadCropImage = async (cropImage: any) => {
        try {
            toggleIsLoading();
            const res: any = await uploadProfileImage(member.memberCode, convertBase64ToBlob(cropImage), false);
            member.profilePicture = res.data.mediaUrl
            dispatch(setUserData(member));
            await updateState();
            toggleIsLoading();
        } catch (e) {
            toggleIsLoading();
            NiceModal.show("error_modal", {
                headerTitle: "שגיאה",
                errorContent: "שגיאה לא צפויה",
            });
        }

    };

    // if (image) {
    //     return (
    //         <li className="edit_pict_item">
    //             <a href="#" className="edit_pict_link w-input delete w-inline-block"></a>
    //             <img src={image.mediaUrl} loading="lazy" alt="" className="item_pict" />
    //             <a href="#" className="pict_minus w-inline-block" onClick={() => confirmDeleteImage(image)}>
    //                 <img src="/assets/images/ic_pict_close.svg" loading="lazy" alt="" />
    //             </a>
    //         </li>
    //     )
    // } else {
    //     return (
    //         <li className="edit_pict_item" onClick={openUploadFile}>
    //             <img loading="lazy" alt="" className="item_pict no_upload" />
    //             <a href="#" className="edit_pict_link w-input"></a>
    //             <input autoComplete="off" multiple={false} style={{ opacity: 0 }} type="file" accept="image/*" onChange={onSelectFile} ref={inputFile} />
    //             <a href="#" className="pict_plus w-inline-block">
    //                 <img src="/assets/images/ic_pict_plus.svg" loading="lazy" alt="" />
    //             </a>
    //         </li>
    //     )
    // }
    return (
        <>
            {image ? <li className="edit_pict_item">
                <a href="#" className="edit_pict_link w-input delete w-inline-block"></a>
                <img src={image.mediaUrl} loading="lazy" alt="" className="item_pict" />
                <a href="#" className="pict_minus w-inline-block" onClick={() => confirmDeleteImage(image)}>
                    <img src="/assets/images/ic_pict_close.svg" loading="lazy" alt="" />
                </a>
                <a onClick={() => switchToProfilePicture(image)} href="#" className="to_main">הפכו לראשית</a>
            </li> :
                <li className="edit_pict_item" onClick={openUploadFile}>
                    <img loading="lazy" alt="" className="item_pict no_upload" />
                    <a href="#" className="edit_pict_link w-input"></a>
                    <input autoComplete="off" multiple={false} style={{ opacity: 0 }} type="file" accept="image/*" onChange={onSelectFile} ref={inputFile} />
                    <a href="#" className="pict_plus w-inline-block">
                        <img src="/assets/images/ic_pict_plus.svg" loading="lazy" alt="" />
                    </a>
                </li>}

        </>
    )




}



export default ImageContainer;